module.exports = __webpack_public_path__ + "img/regensburg_raumschale.df7a6651.jpg";